const prefix = "/";

export default [
  {
    path: `${prefix}nao-autorizado`,
    meta: { auth: true, public: false },
    title: "Acesso não autorizado.",
    name: "Forbidden",
    component: () => import(`../views/error/403/index.vue`),
  },
];
